import type { AllRouteEndpoints } from "../routeTypes";

export const commentsTargetThreads = "/comments/:target/threads";

export const mutationCacheKeys: AllRouteEndpoints[] = [];
